import { applyTheme } from './themeUtils';
import {
  saveTheme,
  saveLogo,
  saveTabs,
  DEFAULT_FONT,
} from './themeStorage';

/**
 * Apply `GET /galleries/:id/public-config` payload to CSS variables + theme storage.
 * Called by GalleryProvider on fetch.
 *
 * @param {object|null|undefined} publicConfig — shape from public-config JSON
 */
export function applyPublicConfigToStorageAndUi(publicConfig) {
  if (!publicConfig) {
    return;
  }
  if (publicConfig.theme && typeof publicConfig.theme === 'object') {
    const t = publicConfig.theme;
    const colors = t.colors || t;
    const font = t.font || DEFAULT_FONT;
    applyTheme({ colors, font });
    saveTheme(colors, font);
  }
  if (publicConfig.logo && typeof publicConfig.logo === 'object') {
    const { logo: logoUrl, text } = publicConfig.logo;
    if (typeof logoUrl === 'string' || typeof text === 'string') {
      saveLogo(logoUrl || '/placeholder-logo.svg', text || publicConfig.name || '');
    }
  }
  if (publicConfig.tabs && typeof publicConfig.tabs === 'object') {
    const tabs = publicConfig.tabs;
    saveTabs(
      tabs.floorplan || '',
      tabs.showVenueTab !== false,
      tabs.showMediaFilter !== false,
      tabs.showGuestbookTab !== false,
      tabs.showQAndATab !== false,
      tabs.menu || null
    );
  }
  if (typeof publicConfig.name === 'string' && publicConfig.name.length > 0) {
    document.title = publicConfig.name;
  }
}
